/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Tut_S2_BodyInputs */

const en_fc_tut_s2_body = /** @type {(inputs: Fc_Tut_S2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The layout mirrors Premiere Pro: the Project panel (bottom left) holds your media bins; the Source monitor and Effect Controls share the top left; the Program monitor (top center) plays your sequence; the Timeline sits bottom center; audio meters run down the right edge. The tabs at the top switch between Import, Edit and Export.`)
};

/**
* | output |
* | --- |
* | "The layout mirrors Premiere Pro: the Project panel (bottom left) holds your media bins; the Source monitor and Effect Controls share the top left; the Progra..." |
*
* @param {Fc_Tut_S2_BodyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_tut_s2_body = /** @type {((inputs?: Fc_Tut_S2_BodyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Tut_S2_BodyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_tut_s2_body(inputs)
});
export { fc_tut_s2_body as "fc.tut.s2.body" }